export const BASE_URL = 'document-template';
